import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResetPriceCalculator {
  resetPriceCalculatorValues: Subject<any> = new Subject<any>();
  resetHelvetiaValues: Subject<any> = new Subject<any>();
  resetSjfValues: Subject<any> = new Subject<any>();
  resetKsfValues: Subject<any> = new Subject<any>();
}
